// extracted by mini-css-extract-plugin
export default {"pieChart":"_2YAiTA9yH1ayhI4zye3tCS","pieChartCentreValue":"_3ufqaW4pGWcl9gqa3g7HKu","legend":"_23Ehr7f3PfnoIkzciTMBxa"};